import { Flex, BuseColorModeValue } from '@chakra-ui/react';

import CenteredAuth from 'layouts/publico/variants/Centered';

import DataTable from 'views/publico/webTracking/components/DataTable'; 


export default function WebTrackingDetalle() {
	return (		
		<CenteredAuth
			image={'linear-gradient(135deg, #337ab7 0%, #12518a 100%)'}
			cardTop={{ base: '140px', md: '14vh' }}
			cardBottom={{ base: '50px', lg: 'auto' }}
			mx='0px'>
			<Flex
				maxW={{ base: '100%', md: 'max-content' }}
				mx={{ base: 'auto', lg: '0px' }}
				me='auto'
				justifyContent='center'
				px={{ base: '20px', md: '0px' }}
				flexDirection='column'>
					<DataTable  />
			</Flex>
		</CenteredAuth>
	);
}